// libraries.
import { Button } from 'react-bootstrap';
import { useState } from 'react';

// slices.
import AlertToast, {
  AlertTypes,
} from '../../../../../Pricing/components/AlertToast/AlertToast';
import { useHandleMutationToast } from '../../../../hooks/useHandleMutationToast';
import { useUpdateApproverTaskMutation } from '../../../../../../domains/approver-review';

// selector.
import { ActionTaskEnum } from '../ApproverTaskAction';
import { ApproverTaskItem } from '../../../../../../domains/approver-review/interfaces/interfaces';

// utils.
import { ModalLayout } from '../../../../../../shared/ModalLayout/ModalLayout';
import { getSwapButtonInfo } from '../../utils/approverTaskUtils';

// assets.
import warningIcon from '../../../../../../assets/icons/warning-icon.svg';

import { DropdownAgents } from './DropdownAgents';
import { Tooltip } from '../../../../../../shared/Tooltip/Tooltip';

interface ChangeApproverTaskProps {
  approverTask: ApproverTaskItem;
}

export const ChangeApproverTask = ({
  approverTask,
}: ChangeApproverTaskProps) => {
  const [showModal, setShowModal] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState<string>('');
  const [alertData, setAlertData] = useState<{
    type: AlertTypes;
    text: string;
  }>({
    type: 'success',
    text: '',
  });

  const country = localStorage.getItem('country') || '';

  const { icon, label, isDisabled } = getSwapButtonInfo(approverTask);

  const [mutateAssignTask, { isLoading, isError, isSuccess }] =
    useUpdateApproverTaskMutation();

  const handleClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const setAlert = ({
    type,
    text,
    show,
  }: {
    type: AlertTypes;
    text: string;
    show: boolean;
  }) => {
    setAlertData({ type, text });
    setShowAlert(show);
  };

  const handleReassignTask = () => {
    mutateAssignTask({
      agent: selectedAgent,
      id: approverTask.id,
      country: country,
      task_type: approverTask.task_type,
    });
  };
  useHandleMutationToast({
    isError,
    isSuccess,
    setShowModal,
    setAlert,
  });

  const shouldShowButton =
    approverTask.status === ActionTaskEnum.PENDING ||
    approverTask.status === ActionTaskEnum.PROGRESS;

  if (!shouldShowButton) return null;

  const renderButton = () => (
    <Button
      disabled={isDisabled}
      variant="link"
      className="d-flex p-1 align-items-center gap-1 justify-content-start text-danger rows"
      onClick={handleClick}
      style={isDisabled ? { pointerEvents: 'none' } : undefined}
    >
      <img src={icon} alt="swap icon" />
      {label}
    </Button>
  );

  return (
    <>
      {isDisabled ? (
        <Tooltip
          id="swap"
          message="La tarea está en progreso <br /> por otro agente"
          position="bottom"
          multiline
        >
          <span className="d-inline-block">{renderButton()}</span>
        </Tooltip>
      ) : (
        renderButton()
      )}
      <AlertToast
        text={alertData.text}
        type={alertData.type}
        showAlert={showAlert}
        setShowAlert={() => setShowAlert(false)}
      />
      <ModalLayout
        disabled={isLoading || !selectedAgent}
        icon={warningIcon}
        show={showModal}
        handleClose={handleCloseModal}
        handleSave={handleReassignTask}
        title="Reasignar tarea"
        subtitle="Selecciona el agente"
        description=""
      >
        <DropdownAgents
          onSelectAgent={setSelectedAgent}
          value={selectedAgent}
        />
      </ModalLayout>
    </>
  );
};
